package org.catharsis.spendtel.ui.components

import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import io.github.oikvpqya.compose.fastscroller.ScrollbarStyle
import io.github.oikvpqya.compose.fastscroller.ThumbStyle
import io.github.oikvpqya.compose.fastscroller.TrackStyle
import io.github.oikvpqya.compose.fastscroller.VerticalScrollbar
import io.github.oikvpqya.compose.fastscroller.rememberScrollbarAdapter
import org.catharsis.spendtel.feature.presentation.web.webCompactBreakpoint

private val scrollbarThumb = Color(0xFF94A3B8)
private val scrollbarTrack = Color(0xFFCBD5E1)

private fun spendTelWebScrollbarStyle() = ScrollbarStyle(
    minimalHeight = 32.dp,
    thickness = 10.dp,
    hoverDurationMillis = 200,
    thumbStyle = ThumbStyle(
        shape = RoundedCornerShape(5.dp),
        unhoverColor = scrollbarThumb.copy(alpha = 0.55f),
        hoverColor = scrollbarThumb.copy(alpha = 0.85f),
    ),
    trackStyle = TrackStyle(
        shape = RoundedCornerShape(7.dp),
        unhoverColor = scrollbarTrack.copy(alpha = 0.22f),
        hoverColor = scrollbarTrack.copy(alpha = 0.32f),
    ),
)

@Composable
actual fun PlatformScrollableColumn(
    modifier: Modifier,
    scrollState: ScrollState,
    content: @Composable ColumnScope.() -> Unit,
) {
    BoxWithConstraints(modifier = modifier.fillMaxSize()) {
        val showScrollbar = maxWidth >= webCompactBreakpoint

        Box(modifier = Modifier.fillMaxSize()) {
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .verticalScroll(scrollState)
                    .padding(end = if (showScrollbar) 12.dp else 0.dp),
                content = content,
            )

            if (showScrollbar) {
                VerticalScrollbar(
                    adapter = rememberScrollbarAdapter(scrollState = scrollState),
                    style = spendTelWebScrollbarStyle(),
                    modifier = Modifier
                        .align(Alignment.CenterEnd)
                        .fillMaxHeight()
                        .padding(vertical = 8.dp),
                    enablePressToScroll = false,
                )
            }
        }
    }
}
